export default [
  { slug: "bcc", name: "Butte Credit", logoUrl: "bcc-logo.png" },
  { slug: "cby", name: "CBY", logoUrl: "cby-logo.png" },
  { slug: "ccs", name: "CCS", logoUrl: "ccs-logo.png" },
  { slug: "csl", name: "CSL", logoUrl: "csl-logo.png" },
  { slug: "cso", name: "CSO", logoUrl: "cso-logo.png" },
  { slug: "dco", name: "DebtCo", logoUrl: "debtco-logo.png" },
  { slug: "hudm", name: "Hudson Management", logoUrl: "hudm-logo.jpg" },
  { slug: "liveoak", name: "Live Oak", logoUrl: "liveoak-logo.png" },
  { slug: "solv", name: "Solverity", logoUrl: "solv-logo.png" },
  { slug: "sca", name: "Southern Credit Adjusters", logoUrl: "sca-logo.png" },
  { slug: "tsc", name: "TSC", logoUrl: "tsc-logo.png" },
  { slug: "gnw", name: "Grant & Weber", logoUrl: "gnw-logo.png" },
  { slug: "cfs", name: "Chapman Financial Services", logoUrl: "cfs-logo.png" },
  { slug: "pam", name: "Professional Account Management", logoUrl: "pam-logo.png" },
  { slug: "efe", name: "Executive Financial Enterprises", logoUrl: "efe-logo.png" },
  {
    slug: "ccla",
    name: "Commercial Collection Consultants - Los Angeles",
    logoUrl: "ccla-logo.png",
  },
  { slug: "cctx", name: "Commercial Collection Consultants - Dallas", logoUrl: "cctx-logo.png" },
  { slug: "fai", name: "Financial Assistance Inc", logoUrl: "fai-logo.png" },
  { slug: "alcs", name: "Allied Collection Services", logoUrl: "alcs-logo.png" },
  { slug: "acs", name: "American Collection Systems", logoUrl: "acs-logo.png" },
  { slug: "cbb", name: "Central Business Bureau Inc", logoUrl: "cbb-logo.png" },
  { slug: "cbs", name: "Credit Bureau Systems Collection Services", logoUrl: "cbs-logo.png" },
  { slug: "hrrg", name: "HRRG", logoUrl: "hrrg-logo.png" },
  { slug: "abs", name: "Accounts Billing Service", logoUrl: "abs-logo.png" },
  { slug: "ncs", name: "NCSPlus", logoUrl: "ncs-logo.png" },
  { slug: "nova", name: "Nova Collect", logoUrl: "nova-logo.png" },
  { slug: "test", name: "Test" },
];
